export const APP_NAME = "Sales Forecasting";
export const APP_LINK = "sales-forecasting";
